import React from 'react';
import {Alert, Col, Form, Input, Modal, Row} from 'antd';
import {nameof} from 'src/core/utils/object';
import autobind from 'autobind-decorator';
import {withTranslation} from 'react-i18next'
import HttpService, {formatMessage} from '../core/services/http.service';
import {resolve} from 'src/inversify.config';
import {createPatch} from 'rfc6902';
import {TimesheetTaskItem} from 'src/pages/timesheet'

let FormItem = Form.Item;
let TextArea = Input.TextArea;

class TimesheetTaskEditor extends React.Component<any, any> {
    @resolve(HttpService)
    private httpService!: HttpService;

    constructor(props: any) {
        super(props);
        this.state = {
            shown: true
        }
    }

    @autobind
    private onCancel() {
        this.setState({ shown: false });
        if (this.props.onClose)
            this.props.onClose();
    }

    @autobind
    private onSave() {
        var self = this;
        return new Promise(() => {
            self.props.form.validateFields((event: any) => {
                var values = self.props.form.getFieldsValue();
                if (!event) {
                    var result = Object.assign(Object.assign({}, self.props.item), values);
                    this.httpService!.patch(`${process.env.PUBLIC_URL}/api/v1/timesheet/${self.props.companyId}/${self.props.employeeId}/${self.props.timesheetId}/update/${self.props.projectTaskId}`, createPatch(self.props.item, result)).then(() => {
                        this.setState({ shown: false });
                        if (this.props.onClose)
                            this.props.onClose(values.projectTaskTitle, values.notes);
                    }).catch(error => this.setState({ error: error }));
                }
            });
        })        
    }

    public render() {
        const { t, item } = this.props;
        return (<Modal
            maskClosable={false}
            visible={this.state.shown}
            onCancel={this.onCancel}
            onOk={this.onSave}
            closable={false}
            width='800px'
            title={t("Edit task")}>
            {this.state.error &&
                <Alert type='error'
                    message={t("Error")}
                    description={formatMessage(this.state.error)}
                />
            }
            <Form id="modaForm" onSubmit={() => { if (this.props.onSave) { this.props.onSave(); } }}>
                <Row gutter={24}>
                    <Col span={24}>
                        <FormItem label={t("Title")}>
                            {this.props.form.getFieldDecorator(nameof<TimesheetTaskItem>("projectTaskTitle"), {
                                initialValue: item.projectTaskTitle,
                                rules: [{ required: true, message: t('Task title required') }],
                            })(
                                <Input placeholder={t("Title")} type="text" />
                            )}
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <FormItem label={t("Description")}>
                            {this.props.form.getFieldDecorator(nameof<TimesheetTaskItem>('notes'), {
                                initialValue: item.notes,
                            })(
                                <TextArea placeholder={t('Description')} />
                            )}
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </Modal>
        );
    }
}

export default withTranslation()(Form.create({})(TimesheetTaskEditor) as any) as any;